import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchMouleSelectionMyairports } from "../AirlineImages/FetchModule";
import {
  fetchCategorySelection,
  fetchGeoLocationPromotionLevelsSelection,
  fetchLGeoLocationPromotionSelection,
  fetchLocationMyAirportSelection,
  fetchNotificationTypeSelection,
  fetchPromotionMyAirportSelection,
  fetchRepeatTypeSelection,
  fetchTypeShopStoreSelection,
} from "../ShopAndDine/FetchDropdownApi";

export const getMyAirportsPromotionsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  notificationType: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  repeatType: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  promotion: [
    {
      fieldName: "Modules / Airports",
      fieldValue: "project_airport_id",
      className: "col-span-6",
      type: "select",
      name: "project_airport_id",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionMyairports,
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Square Image",
      fieldValue: "square_image",
      className: "col-span-6",
      type: "image",
      name: "square_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Square Image",
      placeholder: "Select Square Image",
      validation: { required: "Square Image is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Long Description (EN)",
      fieldValue: "long_description",
      className: "col-span-6",
      type: "text",
      name: "long_description",
      formType: "richText",
      label: "Long Description (EN)",
      placeholder: "Enter Long Description (EN)",
      validation: { required: "Long Description (EN) is required" },
      note: "This field is applicable for Myairports and Eraman",
    },
    {
      fieldName: "Long Description (MS)",
      fieldValue: "long_description_malay",
      className: "col-span-6",
      type: "text",
      name: "long_description_malay",
      formType: "richText",
      label: "Long Description (MS)",
      placeholder: "Enter Long Description (MS)",
      note: "This field is applicable for Myairports and Eraman",
      // validation: { required: "Long Description (EN) is required" },
    },
    {
      fieldName: "Long Description (ZH)",
      fieldValue: "long_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "long_description_mandarin",
      formType: "richText",
      label: "Long Description (ZH)",
      placeholder: "Enter Long Description (ZH)",
      note: "This field is applicable for Myairports and Eraman",
      // validation: { required: "Long Description (EN) is required" },
    },

    // {
    //   fieldName: "Short Description (EN)",
    //   fieldValue: "short_description",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "short_description",
    //   formType: "richText",
    //   label: "Short Description (EN)",
    //   placeholder: "Enter Short Description (EN)",
    //   validation: { required: "Short Description (EN) is required" },
    // },
    // {
    //   fieldName: "Short Description (MS)",
    //   fieldValue: "short_description_malay",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "short_description_malay",
    //   formType: "richText",
    //   label: "Short Description (MS)",
    //   placeholder: "Enter Short Description (MS)",
    //   // validation: { required: "Long Description (EN) is required" },
    // },
    // {
    //   fieldName: "Short Description (ZH)",
    //   fieldValue: "short_description_mandarin",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "short_description_mandarin",
    //   formType: "richText",
    //   label: "Short Description (ZH)",
    //   placeholder: "Enter Short Description (ZH)",
    //   // validation: { required: "Long Description (EN) is required" },
    // },

    {
      fieldName: "Terms and Condition (EN)",
      fieldValue: "terms_condition",
      className: "col-span-6",
      type: "text",
      name: "terms_condition",
      formType: "richText",
      label: "Terms and Condition (EN)",
      placeholder: "Enter Terms and Condition (EN)",
      // validation: { required: "Terms and Condition (EN) is required" },
    },
    {
      fieldName: "Terms and Condition (MS)",
      fieldValue: "terms_condition_malay",
      className: "col-span-6",
      type: "text",
      name: "terms_condition_malay",
      formType: "richText",
      label: "Terms and Condition (MS)",
      placeholder: "Enter Terms and Condition (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Terms and Condition (ZH)",
      fieldValue: "terms_condition_mandarin",
      className: "col-span-6",
      type: "text",
      name: "terms_condition_mandarin",
      formType: "richText",
      label: "Terms and Condition (ZH)",
      placeholder: "Enter Terms and Condition (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Sequence No.",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "number",
      label: "Sequence No.",
      placeholder: "Enter Sequence No.",
      // validation: { required: "Sequence No. is required" },
    },

    {
      fieldName: "Repeat for Days",
      fieldValue: "repeat_for_days",
      className: "col-span-6",
      type: "text",
      name: "repeat_for_days",
      formType: "input",
      label: "Repeat for Days",
      placeholder: "Repeat for Days",
      validation: { required: "Repeat for Days is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Frequency Count",
      fieldValue: "frequency_count",
      className: "col-span-6",
      type: "text",
      name: "frequency_count",
      formType: "input",
      label: "Frequency Count",
      placeholder: "Frequency Count",
      validation: { required: "Frequency Count is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Frequency Time",
      fieldValue: "frequency_time",
      className: "col-span-6",
      type: "text",
      name: "frequency_time",
      formType: "input",
      label: "Frequency Time",
      placeholder: "Frequency Time",
      validation: { required: "Frequency Time is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Location",
      fieldValue: "location",
      className: "col-span-6",
      type: "text",
      name: "location",
      formType: "input",
      label: "Location",
      placeholder: "Location",
      validation: { required: "Location is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Offer",
      fieldValue: "offer",
      className: "col-span-6",
      type: "text",
      name: "offer",
      formType: "input",
      label: "Offer",
      placeholder: "Offer",
      validation: { required: "Offer is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Navigation Link",
      fieldValue: "navigation_link",
      className: "col-span-6",
      type: "text",
      name: "navigation_link",
      formType: "input",
      label: "Navigation Link",
      placeholder: "Navigation Link",
      validation: { required: "Navigation Link is required" },
      note: "This field is applicable only for Myairports and Passenger",
    },
    {
      fieldName: "Start Date",
      fieldValue: "start_date",
      className: "col-span-6",
      type: "dateTime",
      name: "start_date",
      formType: "dateTime",
      label: "Start Date",
      placeholder: "Enter Start Date",
      // disabledPreviousDateTime: true,
      // validation: { required: "Start Date is required" },
    },
    {
      fieldName: "End Date",
      fieldValue: "end_date",
      className: "col-span-6",
      type: "dateTime",
      name: "end_date",
      formType: "dateTime",
      label: "End Date",
      placeholder: "Enter End Date",
      // disabledPreviousDateTime: true,
      // validation: { required: "End Date is required" },
    },

    {
      fieldName: "Notification Type",
      fieldValue: "notification_type",
      className: "col-span-6",
      type: "select",
      name: "notification_type",
      formType: "select",
      label: "Notification Type",
      placeholder: "Select Notification Type",
      loadOptions: fetchNotificationTypeSelection,
      validation: { required: "Notification Type is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Repeat Type",
      fieldValue: "repeat_type",
      className: "col-span-6",
      type: "select",
      name: "repeat_type",
      formType: "select",
      label: "Repeat Type",
      placeholder: "Select Repeat Type",
      loadOptions: fetchRepeatTypeSelection,
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Type",
      fieldValue: "type",
      className: "col-span-6",
      type: "select",
      name: "type",
      formType: "select",
      label: "Type",
      placeholder: "Select Type",
      loadOptions: fetchTypeShopStoreSelection,
      validation: { required: "Type is required" },
      note: "This field is applicable only for Myairports",
    },
    {
      fieldName: "Category",
      fieldValue: "shop_category",
      className: "col-span-6",
      type: "select",
      name: "shop_category",
      formType: "select",
      label: "Category",
      placeholder: "Select Category",
      loadOptions: fetchCategorySelection,
      validation: { required: "Category is required" },
      note: "This field is applicable only for Myairports",
    },

    // {
    //   fieldName: "Zone",
    //   fieldValue: "zone",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "zone",
    //   formType: "select",
    //   options: [
    //     {
    //       value: "Public",
    //       label: "Public",
    //     },
    //     {
    //       value: "Passenger",
    //       label: "Passenger",
    //     },
    //   ],
    //   label: "Zone",
    //   placeholder: "Select Zone",
    //   // validation: { required: "Zone is required" },
    // },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],

  geoLocationPromotions: [
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Square Image",
      fieldValue: "square_image",
      className: "col-span-6",
      type: "image",
      name: "square_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Square Image",
      placeholder: "Select Square Image",
      validation: { required: "Square Image is required" },
    },
    {
      fieldName: "Logo",
      fieldValue: "logo",
      className: "col-span-6",
      type: "image",
      name: "logo",
      formType: "file",
      usedFileType: "image/*",
      label: "Logo",
      placeholder: "Select Logo",
      validation: { required: "Logo is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "header",
      className: "col-span-6",
      type: "text",
      name: "header",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "header_malay",
      className: "col-span-6",
      type: "text",
      name: "header_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "header_mandarin",
      className: "col-span-6",
      type: "text",
      name: "header_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },

    {
      fieldName: "Short Description (EN)",
      fieldValue: "short_description",
      className: "col-span-6",
      type: "text",
      name: "short_description",
      formType: "richText",
      label: "Short Description (EN)",
      placeholder: "Enter Short Description (EN)",
      validation: { required: "Short Description (EN) is required" },
    },
    {
      fieldName: "Short Description (MS)",
      fieldValue: "short_description_malay",
      className: "col-span-6",
      type: "text",
      name: "short_description_malay",
      formType: "richText",
      label: "Short Description (MS)",
      placeholder: "Enter Short Description (MS)",
      // validation: { required: "Long Description (EN) is required" },
    },
    {
      fieldName: "Short Description (ZH)",
      fieldValue: "short_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "short_description_mandarin",
      formType: "richText",
      label: "Short Description (ZH)",
      placeholder: "Enter Short Description (ZH)",
      // validation: { required: "Long Description (EN) is required" },
    },

    {
      fieldName: "Logo Text",
      fieldValue: "logo_text",
      className: "col-span-6",
      type: "text",
      name: "logo_text",
      formType: "input",
      label: "Logo Text",
      placeholder: "Logo Text",
      validation: { required: "Logo Text is required" },
    },

    {
      fieldName: "Type",
      fieldValue: "type",
      className: "col-span-6",
      type: "select",
      name: "type",
      formType: "select",
      label: "Type",
      placeholder: "Select Type",
      loadOptions: fetchTypeShopStoreSelection,
      validation: { required: "Type is required" },
    },
    {
      fieldName: "Category",
      fieldValue: "shop_category",
      className: "col-span-6",
      type: "select",
      name: "shop_category",
      formType: "select",
      label: "Category",
      placeholder: "Select Category",
      loadOptions: fetchCategorySelection,
      validation: { required: "Category is required" },
    },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "project_airport_id",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "project_airport_id",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection,
    // },
    {
      fieldName: "Zone",
      fieldValue: "zone_selection",
      className: "col-span-6",
      type: "select",
      name: "zone_selection",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      validation: { required: "Zone is required" },
    },
    {
      fieldName: "Level",
      fieldValue: "levels",
      className: "col-span-6",
      type: "select",
      name: "levels",
      formType: "select",
      label: "Level",
      placeholder: "Select Level",
      loadOptions: fetchLocationMyAirportSelection,
      validation: { required: "Level is required" },
    },
    {
      fieldName: "Promotion",
      fieldValue: "parent_id_promo",
      className: "col-span-6",
      type: "select",
      name: "parent_id_promo",
      formType: "select",
      label: "Category",
      placeholder: "Select Category",
      loadOptions: fetchPromotionMyAirportSelection,
      validation: { required: "Promotion is required" },
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  geoLocationPromotionLevels: [
    {
      fieldName: "Technical ID",
      fieldValue: "technical_id",
      className: "col-span-6",
      type: "text",
      name: "technical_id",
      formType: "input",
      label: "Technical ID",
      placeholder: "Technical ID",
      validation: { required: "Technical ID is required" },
    },
    {
      fieldName: "Document URL",
      fieldValue: "document_url",
      className: "col-span-6",
      type: "text",
      name: "document_url",
      formType: "input",
      label: "Document URL",
      placeholder: "Document URL",
      validation: { required: "Document URL is required" },
    },
    {
      fieldName: "Refer Document Text",
      fieldValue: "refer_document_text",
      className: "col-span-6",
      type: "text",
      name: "refer_document_text",
      formType: "input",
      label: "Refer Document Text",
      placeholder: "Refer Document Text",
      validation: { required: "Refer Document Text is required" },
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_url",
      className: "col-span-6",
      type: "text",
      name: "redirect_url",
      formType: "input",
      label: "Redirect URL",
      placeholder: "Redirect URL",
      validation: { required: "Redirect URL is required" },
    },

    {
      fieldName: "Long Description (EN)",
      fieldValue: "long_description",
      className: "col-span-6",
      type: "text",
      name: "long_description",
      formType: "richText",
      label: "Long Description (EN)",
      placeholder: "Enter Long Description (EN)",
      validation: { required: "Long Description (EN) is required" },
    },
    {
      fieldName: "Long Description (MS)",
      fieldValue: "long_description_malay",
      className: "col-span-6",
      type: "text",
      name: "long_description_malay",
      formType: "richText",
      label: "Long Description (MS)",
      placeholder: "Enter Long Description (MS)",
      // validation: { required: "Long Description (EN) is required" },
    },
    {
      fieldName: "Long Description (ZH)",
      fieldValue: "long_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "long_description_mandarin",
      formType: "richText",
      label: "Long Description (ZH)",
      placeholder: "Enter Long Description (ZH)",
      // validation: { required: "Long Description (EN) is required" },
    },

    {
      fieldName: "Terms Conditions (EN)",
      fieldValue: "terms_conditions",
      className: "col-span-6",
      type: "text",
      name: "terms_conditions",
      formType: "richText",
      label: "Terms Conditions (EN)",
      placeholder: "Enter Terms Conditions (EN)",
      validation: { required: "Terms Conditions (EN) is required" },
    },
    {
      fieldName: "Terms Conditions (MS)",
      fieldValue: "terms_conditions_malay",
      className: "col-span-6",
      type: "text",
      name: "terms_conditions_malay",
      formType: "richText",
      label: "Terms Conditions (MS)",
      placeholder: "Enter Terms Conditions (MS)",
      // validation: { required: "Long Description (EN) is required" },
    },
    {
      fieldName: "Terms Conditions (ZH)",
      fieldValue: "terms_conditions_mandarin",
      className: "col-span-6",
      type: "text",
      name: "terms_conditions_mandarin",
      formType: "richText",
      label: "Terms Conditions (ZH)",
      placeholder: "Enter Terms Conditions (ZH)",
      // validation: { required: "Long Description (EN) is required" },
    },

    {
      fieldName: "Level",
      fieldValue: "levels",
      className: "col-span-6",
      type: "select",
      name: "levels",
      formType: "select",
      label: "Level",
      placeholder: "Select Level",
      loadOptions: fetchLocationMyAirportSelection,
      validation: { required: "Level is required" },
    },

    {
      fieldName: "Geo Location Promotion",
      fieldValue: "parent_id_promo",
      className: "col-span-6",
      type: "select",
      name: "parent_id_promo",
      formType: "select",
      label: "Geo Location Promotion",
      placeholder: "Select Geo Location Promotion",
      loadOptions: fetchLGeoLocationPromotionSelection,
      validation: { required: "Geo Location Promotion is required" },
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  geoLocationOffer: [
    {
      fieldName: "Details",
      fieldValue: "details",
      className: "col-span-6",
      type: "text",
      name: "details",
      formType: "input",
      label: "Details",
      placeholder: "Details",
      validation: { required: "Details is required" },
    },
    {
      fieldName: "Offer Percentage",
      fieldValue: "offer_percentage",
      className: "col-span-6",
      type: "text",
      name: "offer_percentage",
      formType: "input",
      label: "Offer Percentage",
      placeholder: "Offer Percentage",
      validation: { required: "Offer Percentage is required" },
    },
    {
      fieldName: "Validity",
      fieldValue: "validity",
      className: "col-span-6",
      type: "text",
      name: "validity",
      formType: "input",
      label: "Validity",
      placeholder: "Validity",
      validation: { required: "Validity is required" },
    },

    {
      fieldName: "Geo Location Promotion Levels",
      fieldValue: "parent_id_promo",
      className: "col-span-6",
      type: "select",
      name: "parent_id_promo",
      formType: "select",
      label: "Geo Location Promotion Levels",
      placeholder: "Select Geo Location Promotion Levels",
      loadOptions: fetchGeoLocationPromotionLevelsSelection,
      validation: { required: "Geo Location Promotion Levels is required" },
    },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
